<template>
    <div>
      <headerSection></headerSection>

      <div id="main__content" class="rewards-page">
        <div class="x-main-container">
          <div class="x-main-content">
            <!-- Hero Section -->
            <div class="hero-section">
              <div class="floating-ball ball-1"></div>
              <div class="floating-ball ball-2"></div>
              <div class="floating-ball ball-3"></div>

              <div class="hero-content">
                <div class="trophy-icon-wrapper">
                  <span class="trophy-icon">🏆</span>
                </div>
                <h1 class="title-glow">{{ $t('rewards_page.title') }}</h1>
                <p class="hero-description" v-html="rewardDescription"></p>

                <!-- User Points Display -->
                <div class="points-display" v-if="user && user.coin">
                  <div class="points-card">
                    <span class="points-label">{{ $t('rewards_page.your_points') }}</span>
                    <div class="points-value">
                      <span class="points-icon">⭐</span>
                      <span class="points-number">{{ user.coin }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Rewards Grid -->
            <div class="rewards-container">
              <div class="rewards-grid">
                <div
                  class="reward-card"
                  :class="{ 'locked': checkLocked(item) }"
                  v-for="(item,index) in rewards"
                  :key="index"
                  @click="conFirmRedeem(item)"
                >
                  <div class="reward-image-wrapper">
                    <img
                      class="reward-image"
                      :alt="item.name"
                      :src="item.image"
                      :class="{ 'grayscale': checkLocked(item) }"
                    >
                    <div class="reward-overlay" v-if="!checkLocked(item)">
                      <span class="overlay-text">แลกเลย</span>
                    </div>
                  </div>

                  <div class="reward-info">
                    <h3 class="reward-name">{{ item.name }}</h3>
                    <div class="reward-points">
                      <span class="points-badge">
                        <span class="badge-icon">⭐</span>
                        <span class="badge-text">{{ item.point }} แต้ม</span>
                      </span>
                    </div>

                    <div class="reward-details" v-if="Number(item.turn) > 0 || Number(item.maxwithdraw) > 0">
                      <span class="detail-item" v-if="Number(item.turn) > 0">
                        🔄 เทิร์น {{ item.turn }} เท่า
                      </span>
                      <span class="detail-item" v-if="Number(item.maxwithdraw) > 0">
                        💰 ถอนสูงสุด {{ item.maxwithdraw }}
                      </span>
                    </div>
                  </div>

                  <div class="lock-overlay" v-if="checkLocked(item)">
                    <div class="lock-icon">🔒</div>
                    <div class="lock-text">{{ $t('rewards_page.locked_message') }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer Info -->
            <div class="footer-info">
              <div class="info-card">
                <h2 class="info-title">
                  <a href="https://funbeyond.cc" class="brand-link">FunBeyond</a>
                  <span>&nbsp;{{ $t('rewards_page.subtitle') }}</span>
                </h2>
                <p class="info-description">
                  {{ $t('rewards_page.footer_description') }}
                </p>
              </div>
            </div>

            <footerSection></footerSection>
          </div>
        </div>

        <div class="x-right-sidebar-container"></div>

      </div>
    </div>
  </template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  mounted () {
    const width = screen.width
    if(width <= 480)
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    else
      this.backgroundImage = require('../assets/images/Shiba-BG1.jpg')
    // Bonn.boots.push(function() {
    //   setTimeout(function() {
    //     $('#bankInfoModal').modal('show');
    //   }, 500);
    // });
    this.$store.dispatch('user/getRewards').catch(err => { console.error(err) })
    this.loadRewardDescription()
    // this.checkAnoucement()
  },
  computed: {
    sites_credit () {
      return this.$store.state.user.sites_credit
    },
    user () {
      return this.$store.state.user.user
    },
    rewards () {
      return this.$store.state.user.rewards
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    rewardDescription () {
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      if (this.rewardDescriptions && this.rewardDescriptions[locale] && this.rewardDescriptions[locale].trim() !== '') {
        return this.rewardDescriptions[locale]
      }
      return this.$t('rewards_page.description')
    }
  },
  data () {
    return {
      continueCheck: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      backgroundImage: '',
      disabled: false,
      rewardDescriptions: null
    }
  },
  methods: {
    getRedeemMessage (item) {
      const turn = Number(item.turn) || 0
      const maxwithdraw = Number(item.maxwithdraw) || 0
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      let line1, line3, turnText, withdrawText, separator
      if (locale === 'en') {
        line1 = `Do you want to use ${item.name} coins for games or casino only?`
        turnText = turn > 0 ? `Make a turnover of ${turn} times` : ''
        withdrawText = maxwithdraw > 0 ? `withdraw up to ${maxwithdraw} times` : ''
        separator = ', '
        line3 = 'Bonus cannot be withdrawn'
      } else if (locale === 'my') {
        line1 = `${item.name} အကြွေစေ့များဖြင့် ဂိမ်းနှင့် ကာစီနို အတွက်သာ ကစားလိုပါသလား?`
        turnText = turn > 0 ? `${turn} ဆ လည်ပတ်ရမည်` : ''
        withdrawText = maxwithdraw > 0 ? `အများဆုံး ${maxwithdraw} ဆ ထုတ်ယူနိုင်သည်` : ''
        separator = '၊ '
        line3 = 'ဘောနပ်စ်ကို ထုတ်ယူ၍မရပါ'
      } else {
        line1 = `ต้องการใช้เหรียญ ${item.name} เล่นเฉพาะเกม หรือคาสิโน`
        turnText = turn > 0 ? `ทำยอด ${turn} เท่า` : ''
        withdrawText = maxwithdraw > 0 ? `ถอนสูงสุด ${maxwithdraw} เท่า` : ''
        separator = ' '
        line3 = 'ไม่สามารถถอนโบนัสได้'
      }
      const parts = [turnText, withdrawText].filter(p => p)
      const lines = [line1]
      if (parts.length > 0) {
        lines.push(parts.join(separator))
        lines.push(line3)
      }
      return lines.join('\n')
    },
    async loadRewardDescription () {
      try {
        const snapshot = await firebase.database().ref('/condition/rewardDescription').once('value')
        if (snapshot.val()) this.rewardDescriptions = snapshot.val()
      } catch (e) { console.error(e) }
    },
    checkLocked (item) {
      return (!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)
    },
    checkStyle (item) {
      if ((!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        return 'border-radius:0px;-webkit-filter: grayscale(100%);filter: grayscale(100%);'
      }
    },
    async conFirmRedeem (item) {
      // ป้องกันการคลิกถ้า locked
      if (this.checkLocked(item)) {
        return
      }

      if (!this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally(() => {
          this.$store.commit('user/SET_LOADING', false)
          if (this.user.coin && Number(this.user.coin) >= Number(item.point)) {
            this.$confirm(
              {
                message: this.getRedeemMessage(item),
                button: {
                  yes: this.$t('rewards_page.confirm'),
                  no: this.$t('rewards_page.cancel')
                },
                callback: confirm => {
                  if (confirm) {
                    this.$store.commit('user/SET_LOADING', true)
                    setTimeout(() => {
                      firebase.firestore().collection('redeem').add({
                        userkey: this.user.key,
                        code: this.user.code,
                        reward: item.key,
                        type: item.type,
                        credit: (item.credit) ? item.credit : '',
                        point: item.point,
                        status: false,
                        createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                      }).then((result) => {
                        axios({
                          method: 'post',
                          url: 'https://api.funbeyond.cc/qmovetowallet/redeem',
                          data: {
                            code: this.user.code,
                            key: result.id
                          }
                        })
                        this.$store.commit('user/SET_LOADING', false)
                      })
                    }, Math.floor(Math.random() * 3000))
                  }
                }
              }
            )
          }
        }).catch(err => { console.error(err) })
        setTimeout(() => {
          this.disabled = false
        }, 2000)
      }
    },
    async redeem (item) {
      if (!(!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)) {
        if (item.type === 'credit') {
          this.$store.dispatch('user/refreshCreditAll').finally(res => {
            if (this.sites_credit.credit >= 5) {
              this.$swal({ icon: 'error', title: this.$t('rewards_page.title2'), html: this.$t('rewards_page.warning') })
            } else {
              this.conFirmRedeem(item)
            }
          })
        } else {
          this.conFirmRedeem(item)
        }
      }
    }
    // async moveCreditToWallet () {
    //   this.$store.commit('user/SET_LOADING', true)
    //   const user = this.getUserId()
    //   this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
    //   this.$store.dispatch('user/getLastBonus', user).finally(res => {
    //     this.$store.commit('user/SET_LOADING', false)
    //     if (this.lastbonus.turncredit) {
    //       this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
    //     }
    //   }).catch(err => { console.error(err) })
    // },
  }
}
</script>

<style scoped>
/* ===== Page Base ===== */
.rewards-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1b1b41 0%, #492666 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* ===== Hero Section ===== */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(131, 9, 162, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 0;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== Trophy Icon ===== */
.trophy-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.trophy-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(255, 193, 7, 0.4));
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* ===== Floating Balls ===== */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #8309a2, #ffc107);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #fe8a02, #ffc107);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #492666, #8309a2);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(25px, -25px) rotate(180deg); }
}

/* ===== Title ===== */
.title-glow {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  background: linear-gradient(135deg, #ce93d8, #8309a2, #ce93d8);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: purpleShine 3s linear infinite;
}

@keyframes purpleShine {
  to {
    background-position: 200% center;
  }
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 25px;
}

/* ===== Points Display ===== */
.points-display {
  margin-top: 30px;
}

.points-card {
  background: linear-gradient(145deg, rgba(255, 193, 7, 0.15), rgba(255, 193, 7, 0.05));
  border: 2px solid rgba(255, 193, 7, 0.3);
  border-radius: 16px;
  padding: 20px 30px;
  backdrop-filter: blur(10px);
  display: inline-block;
  min-width: 250px;
}

.points-label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
  text-align: center;
}

.points-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.points-icon {
  font-size: 32px;
  animation: sparkle 2s ease-in-out infinite;
}

@keyframes sparkle {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    filter: brightness(1.3);
  }
}

.points-number {
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #ffc107, #fe8a02);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ===== Rewards Container ===== */
.rewards-container {
  max-width: 1200px;
  margin: 40px auto 0;
  padding: 0 20px;
}

.rewards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}

/* ===== Reward Card ===== */
.reward-card {
  position: relative;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  backdrop-filter: blur(10px);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.reward-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 10px 30px rgba(131, 9, 162, 0.4);
  border-color: rgba(131, 9, 162, 0.5);
}

.reward-card.locked {
  cursor: not-allowed;
  opacity: 0.6;
}

.reward-card.locked:hover {
  transform: none;
  box-shadow: none;
}

/* ===== Reward Image ===== */
.reward-image-wrapper {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 15px;
  background: rgba(0, 0, 0, 0.2);
}

.reward-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.reward-card:hover .reward-image {
  transform: scale(1.1);
}

.reward-image.grayscale {
  filter: grayscale(100%);
}

.reward-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.9), rgba(73, 38, 102, 0.9));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.reward-card:hover .reward-overlay {
  opacity: 1;
}

.overlay-text {
  font-size: 20px;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* ===== Reward Info ===== */
.reward-info {
  text-align: center;
}

.reward-name {
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin-bottom: 12px;
  line-height: 1.4;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reward-points {
  margin-bottom: 10px;
}

.points-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #ffc107, #fe8a02);
  border-radius: 20px;
  font-size: 16px;
  font-weight: 700;
  color: #1b1b41;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
}

.badge-icon {
  font-size: 18px;
}

.reward-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.detail-item {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* ===== Lock Overlay ===== */
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(3px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  z-index: 5;
}

.lock-icon {
  font-size: 48px;
  margin-bottom: 10px;
  opacity: 0.8;
}

.lock-text {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

/* ===== Footer Info ===== */
.footer-info {
  max-width: 600px;
  margin: 50px auto 0;
  padding: 0 20px;
}

.info-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 16px;
  padding: 30px;
  backdrop-filter: blur(10px);
  text-align: center;
}

.info-title {
  font-size: 22px;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
}

.brand-link {
  color: #ffc107;
  text-decoration: none;
  transition: color 0.3s ease;
}

.brand-link:hover {
  color: #fe8a02;
}

.info-description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin: 0;
}

/* ===== Responsive ===== */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .trophy-icon {
    font-size: 48px;
  }

  .rewards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .points-card {
    min-width: auto;
    width: 100%;
  }

  .points-number {
    font-size: 32px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .trophy-icon {
    font-size: 40px;
  }

  .points-icon {
    font-size: 24px;
  }

  .points-number {
    font-size: 28px;
  }

  .reward-image-wrapper {
    height: 180px;
  }

  .reward-name {
    font-size: 16px;
    min-height: 45px;
  }

  .points-badge {
    font-size: 14px;
    padding: 6px 12px;
  }

  .info-title {
    font-size: 18px;
  }

  .info-card {
    padding: 20px;
  }
}

/* ===== Legacy Support ===== */
@media screen and (max-width: 992px) {
  .resize {
    width: 899px;
  }
}

@media screen and (max-width: 600px) {
  .resize {
    width: 399px;
  }
  .bg-mobile {
    background-color: #1c1c1c;
  }
  .bg-mobile2 {
    margin-right: 0;
  }
}

.btn {
  border-radius: 25px;
  color: #fff;
  border: none;
  padding: 0.8rem 2.5rem;
}

.btn.-btn-redeem {
  background: radial-gradient(100% 100% at 50% 0, #a8ff9c 0, #4dd842 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 1px 2px hsla(0, 7.3%, 92%, 0.24);
}

.btn.-btn-redeem:hover {
  background: radial-gradient(100% 100% at 50% 0, #a8ff9b 0, #33bf28 100%);
}

.btn.-btn-redeem:disabled,
.btn.-btn-redeem[disabled] {
  background: radial-gradient(100% 100% at 50% 0, #cccccc 0, #9e9999 100%);
}
</style>
